import { Route } from '@rtls/core/models/convoy/route.model';
import { randomName } from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts/lib';

export const routeFactory = Factory.makeFactory<Route>({
	longName: Factory.each(() => randomName()),
});
